let _actions = {};

export default class Action {
    static register(id, actionClass) {
        _actions[id] = actionClass;
    }

    static get(options) {
        if (! options) return;

        let decodedOptions = JSON.parse(options);
        let id = decodedOptions.action;
        let param = decodedOptions.param;

        if (! id || id === "") return null;

        if (! _actions.hasOwnProperty(id)) {
            console.error("Action " + id + " is undefined!");
            return null;
        }

        return new _actions[id](param);
    }


    constructor(param) {
        this.param = param;
    }

    applyVariables(target, scope) {

        let ret = target;
        let usedVars = target.match(/\[[^\]]+\]/g);

        if (!usedVars) {
            return target;
        }

        for (let ref of usedVars) {
            let v = ref.replace(/[\[\]]/g, "");

            let path = v.split(".");
            let value = scope;

            //Debug purpose for development, will be removed on run build
            for (let t in scope) {
                console.log(t + ':');
                console.log(scope[t]);
            }

            for (let p of path) {
                if (value.hasOwnProperty(p)) {
                    value = value[p];
                } else {
                    //console.log(ref + " not found");
                    value = null;
                    break;
                }
            }

            if (value !== null) {
                ret = ret.replace(ref, value);
            }
        }

        return ret;
    }

    perform(scope) {
    }

    deactivate() {}
}



// WEBPACK FOOTER //
// ./src/components/chart/actions/Action.js